import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import styles from './ArticleDate.module.scss';

const ArticleDate = ({ published, updated }) => {
    const { t } = useTranslation('common');

    return (
        <div className={styles['ArticleDate']}>
            {published && (
                <div className={styles['ArticleDate__Item']}>
                    <span className={styles['ArticleDate__Label']}>
                        {t('date.published')}
                    </span>{' '}
                    {published}
                </div>
            )}
            {updated && (
                <div className={styles['ArticleDate__Item']}>
                    <span className={styles['ArticleDate__Label']}>
                        {t('date.updated')}
                    </span>{' '}
                    {updated}
                </div>
            )}
        </div>
    );
};

ArticleDate.propTypes = {
    published: PropTypes.string,
    updated: PropTypes.string,
};

ArticleDate.defaultProps = {
    published: '',
    updated: '',
};

export default ArticleDate;
